// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"P9bQ1ydayXdHzR5qfX_PP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EditCompanyByOwner/EditCompanyByOwner.scss
// module id = 1782
// module chunks = 0